import { observable, computed, makeObservable } from 'mobx';

import type { Optional } from 'chaika-common-types';

import { IField } from './IField';

export abstract class AbstractField<V, U, C = U> implements IField<V, U> {
    protected defaultNullValue: Optional<V | U>;

    @observable
    protected fieldValue!: V;

    @observable
    protected fieldName: string;

    constructor(value: V | U | C, name: string) {
        makeObservable(this);

        this.setDefaultValueValue();
        this.setFieldValue(value || (this.defaultNullValue as V | U));
        this.fieldName = name;
    }

    public get name(): string {
        return this.fieldName;
    }

    @computed
    public get hasData(): boolean {
        return typeof this.fieldValue === 'string' ? !!this.fieldValue.trim() : !!this.fieldValue;
    }

    public get hasHtmlPreview(): boolean {
        return false;
    }

    public hasItem(_id: string): boolean {
        return true;
    }

    public getValue(): V {
        return this.fieldValue;
    }

    public getPreview(): string {
        return `${this.fieldValue}`;
    }

    public getUpdateParams(): U {
        return this.makeUpdateParams();
    }

    public isEqual(value: V): boolean {
        return this.fieldValue === value;
    }

    public getItem(_id?: string): void {
        return this.getValue() as any;
    }

    public getItemRevision(id?: string | number): string {
        return this.getPreview();
    }

    public getItemTitle(id?: string | number): string {
        return this.getPreview();
    }

    public getItemContent(id?: string | number): string {
        return this.getPreview();
    }

    public getStatus(id?: string): Optional<string> {
        return undefined;
    }

    public abstract makeUpdateParams(): U;
    protected abstract setFieldValue(value: V | U | C): void;

    protected setDefaultValueValue(): void {
        this.defaultNullValue = '' as any;
    }
}
